import React from 'react';
import { observer } from 'mobx-react-lite';
import { Loader } from '../atoms';
import { useRootStore } from '../../App';
import { Layout } from './Layout';

export const OmniLoginPage = observer(() => {
  const root = useRootStore();
  const { auth } = root.omniLoginStore;
  const jsx = (
    <Layout>
      <Loader />
    </Layout>
  );
  auth().then((r) => {
    return jsx;
  });
  return jsx;
});
